<template>
  <div class="single-comment-wrap">
    <div class="single-comment">
      <comment-header :comment="comment" />
      <ul class="single-comment__body">
        <li>
          <img src="../../../../../../../assets/img/arrow_forward.svg" class="single-comment__body-post">
          <trust
            :trust="getTrust(comment)"
            @setTrust="($event) => $emit('setTrust', {trust: $event, commentId: comment.id})"
          ></trust>
        </li>
        <li class="single-comment__body-item single-comment__text">
          {{comment.text}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  // components
  import CommentHeader from './CommentHeader';
  import Trust from './Trust';
  import ReComments from './ReComments';

  export default  {
    name: 'ReSingle',
    props: {
      comment: {
        type: Object
      },
      post: {
        type: Object
      },
      reComment: {
        type: Boolean
      }
    },
    components: {
      CommentHeader,
      Trust,
      ReComments,
    },
    methods: {
      getTrust(comment) {
        if (!comment.trust_coment) {
          return 0;
        } else {
          return Number(comment.trust_coment);
        }
      },
    },
  };
</script>

<style>
  .single-comment {
    padding: 15px 15px 15px 22px;
    min-height: 120px;
    border-bottom: 1px solid #ebebeb;
  }
  .single-comment:last-child {
    border-bottom: 1px solid transparent;
  }

  .single-comment__body {
    display: flex;
    align-items: flex-start;
    padding: 0;
    margin: 0 0 0 10px;
    list-style: none;
  }
  .single-comment__text {
    color: #1F2F3D;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
  }
  .single-comment__body-post {
    margin-bottom: 10px;
  }
  .single-comment__text {
    margin-left: 30px;
  }
</style>
